"use client";

import Hero from "@/components/hero";
import ScheduleHighlights from "@/components/schedule-highlights";
import PaymentInfo from "@/components/payment-info";
import Header from "@/components/header";
import Footer from "@/components/footer";

export default function Home() {
  return (
    <div
      className="flex min-h-screen flex-col"
      style={{ backgroundColor: "#0F1F05" }}
    >
      <Header />
      <main className="flex-1">
        <Hero />
        <ScheduleHighlights />
        <PaymentInfo />
      </main>
      <Footer />
    </div>
  );
}
